import React, { useMemo } from "react";

const groupUpcomingServices = (courses = []) => {
  const groups = new Map();
  for (const course of Array.isArray(courses) ? courses : []) {
    const key = String(
      course?.orderId || course?.orderId === 0
        ? `order:${course.orderId}`
        : `table:${course?.table || "unknown"}`,
    );
    if (!groups.has(key)) {
      groups.set(key, {
        key,
        table: course?.table || null,
        serverName: course?.serverName || null,
        courses: [],
      });
    }
    groups.get(key).courses.push(course);
  }
  return [...groups.values()]
    .map((group) => ({
      ...group,
      courses: group.courses.sort(
        (left, right) =>
          Number(left?.courseNumber) - Number(right?.courseNumber),
      ),
    }))
    .sort((left, right) =>
      String(left.table || "").localeCompare(String(right.table || ""), "fr", {
        numeric: true,
      }),
    );
};

const KdsUpcomingCourses = ({
  courses = [],
  subtleTextClass = "text-white/70",
  embedded = false,
}) => {
  const services = useMemo(() => groupUpcomingServices(courses), [courses]);
  if (!services.length) return null;

  return (
    <section
      className={`${embedded ? "mt-4" : "mb-6"} rounded-2xl border border-dashed border-blue-300/30 bg-blue-500/5 p-4`}
    >
      <div className="mb-3 flex items-center justify-between gap-3">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-blue-200">
          Suites à venir
        </p>
        <span className="rounded-full border border-blue-300/30 px-3 py-1 text-sm text-blue-100">
          {courses.length} tour{courses.length > 1 ? "s" : ""}
        </span>
      </div>
      <div className={embedded ? "space-y-3" : "grid gap-3 lg:grid-cols-2 2xl:grid-cols-3"}>
        {services.map((service) => (
          <article
            key={service.key}
            className="rounded-xl border border-blue-200/15 bg-black/15 p-3"
          >
            {!embedded && (
              <header className="mb-3 flex items-center justify-between gap-3">
                <strong>Table {service.table || "N/A"}</strong>
                {service.serverName && service.serverName !== "N/A" && (
                  <span className={`text-xs ${subtleTextClass}`}>
                    {service.serverName}
                  </span>
                )}
              </header>
            )}
            <div className="space-y-2">
              {service.courses.map((course) => (
                <div
                  key={course.id}
                  className="rounded-lg border border-white/10 bg-white/[0.03] px-3 py-2"
                >
                  <div className="flex items-center justify-between gap-3">
                    <strong className="text-sm">
                      Tour {course.courseNumber}
                    </strong>
                    <span className="text-xs text-blue-200">
                      {course.hasAddition ? "Rajout · À suivre" : "À suivre"}
                    </span>
                  </div>
                  <div className={`mt-1 text-sm ${subtleTextClass}`}>
                    {course.items
                      .map((item) => `${item.quantity}× ${item.name}`)
                      .join(" · ")}
                  </div>
                </div>
              ))}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default KdsUpcomingCourses;
export { groupUpcomingServices };
